import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchWorkdays } from "../actions/index";
import * as constants from "../const";
import HoursOfServiceModal from "./hours-of-service-modal";
import { showModalAction, getWorkdayAction } from "../actions/index";
import moment from "moment";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/src/SuperResponsiveTableStyle.css";

class NonCertifiedEmployeesWorkday extends React.Component {
  constructor(props) {
    super(props);
  }

  // showing popup with workday details
  showModal(modalObj) {
    this.props.onShowModal(modalObj.modalName);
    var route = localStorage.getItem("route"),
        category = route,
        workdayDate = modalObj.workdayDate;
        workdayDate = moment(workdayDate, 'MM/DD/YYYY')
        workdayDate = workdayDate.format('YYYYMMDD');
    let role = this.props.role;
    this.props.getWorkday(
      constants.actionUrls.WORKDAY_URL + "/" + role + "/" + modalObj.workdayId + "/" + modalObj.certifyStatus
      + "/" + modalObj.empId + "/" + workdayDate + "/" + modalObj.dutyActivityStatus
    );
  }

  render() {
      var route = localStorage.getItem("route"),
          workday = this.props.workday,division = '-',
          full_name = workday && workday.emp_full_name != undefined ? workday.emp_full_name.split(" ") : '',
          first_name = full_name == '' ? '-' : full_name[1],
          last_name = full_name == '' ? '-' :  full_name[0];
      if(workday){
        if(workday.wdy_emp_phone_numbers){
          var empPhoneNumbers = workday.wdy_emp_phone_numbers,
          trimmedPhoneNumber = empPhoneNumbers.substring(0, 12),
          empPhoneNumbers =
          empPhoneNumbers ? empPhoneNumbers.length > 12
            ? trimmedPhoneNumber + "..."
            : trimmedPhoneNumber : '-';
        }
        division = workday.division;
      }
      var modalToOpen = constants.certifyByAdmin ? "Certify_Modal" : "Certified_Modal",
          modalObj = {
            workdayId:workday.id,
            certifyStatus:workday.wdy_certify_status,
            empId:workday.demp_display_Id,
            workdayDate:workday.wdy_date,
            modalName:modalToOpen,
            dutyActivityStatus:workday.dutyActivityStatus
      }
    return (
      <tr>
        <td data-title="Division">{division}</td>
        <td data-title="Employee ID" className="text-center">
          <a className="popUpLink" onClick={() =>
              this.showModal(modalObj)}>{workday.demp_display_Id}
          </a>
        </td>
        <td data-title="Job" className="text-center">{workday.job_class}</td>
        <td data-title="First Name" className="text-center"> {first_name} </td>
        <td data-title="Last Name" className="text-center"> {last_name} </td>
        <td data-title="Service Date" className="text-center"> {workday.wdy_date} </td>
        <td data-title="Phone" className="text-center">
          <span title={workday.wdy_emp_phone_numbers}>{empPhoneNumbers}</span>
        </td>
        <td data-title="HOS" className="text-center">
          {workday.wdy_working_time_hos_adjust ? (
            workday.wdy_working_time_hos_adjust
          ) : (
            workday.wdy_working_time_hos
          )}
        </td>
        <td data-title="TOS" className="text-center">
          {workday.wdy_spread_adjust ? (
            workday.wdy_spread_adjust
          ) : (
            workday.wdy_spread
          )}
        </td>
        <td data-title="Time Elapsed" className={"text-center "+ (route == constants.OUTLAW ? 'hidden' : '')}> {workday.timeElapsed}</td>

      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    authDetails:state.authState
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onShowModal: showModalAction,
      getWorkday: getWorkdayAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(
  NonCertifiedEmployeesWorkday
);
